import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_ERROR,
  AUTH_CHECK,
  AUTH_GET_PERMISSIONS,
  fetchUtils
} from 'react-admin'
import jwtDecode from 'jwt-decode'

const authProvider = (url, httpClient = fetchUtils.fetchJson) => (type, params) => {
  switch (type) {
    case AUTH_LOGIN:
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('user')

      const { username, password } = params
      const options = {
        method: 'POST',
        body: JSON.stringify({ username, password }),
      }
      return httpClient(`${url}/`, options)
        .then(response => {
          const { access, refresh } = response.json
          localStorage.setItem('accessToken', access)
          localStorage.setItem('refreshToken', refresh)
          const decodedToken = jwtDecode(access)
          if(!!decodedToken.user){
            localStorage.setItem("user", JSON.stringify(decodedToken.user))
          }
          if (decodedToken.permissions) {
            localStorage.setItem('role', decodedToken.permissions.role)
            localStorage.setItem(
              'empresas',
              JSON.stringify(decodedToken.permissions.empresas)
            )
          }
        }).catch(err => {
          return Promise.reject()
        })

    case AUTH_LOGOUT:
      const access = localStorage.getItem('accessToken')
      if (!!access){
        httpClient(`${url}/logout/`, {
          method: 'POST',
          headers: new Headers({ 
            Accept: 'application/json',
            Authorization: `Bearer ${access}`
          })
        })
      }
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('role')
      localStorage.removeItem('empresas')
      localStorage.removeItem('user')
      return Promise.resolve()

    case AUTH_ERROR:
      const { status } = params
      if (status === 401 || status === 403) {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('role')
        localStorage.removeItem('empresas')
        localStorage.removeItem('user')
        return Promise.reject()
      }
      return Promise.resolve()

    case AUTH_CHECK:
      const { required=false, roles=[] } = params
      const accessToken = localStorage.getItem('accessToken')

      if (!!accessToken) {
        const accessExpiration = jwtDecode(accessToken).exp
        const now = Math.floor(Date.now() / 1000)

        if (accessExpiration - now <= 60*30) {
          const options = {
            method: 'POST',
            body: JSON.stringify({
              refresh: localStorage.getItem('refreshToken')
            })
          }
          return httpClient(`${url}/refresh/`, options)
            .then(response => {
              const { access, refresh } = response.json
              localStorage.setItem('accessToken', access)
              localStorage.setItem('refreshToken', refresh)
              const decodedToken = jwtDecode(access)
              if(!!decodedToken.user){
                localStorage.setItem("user", JSON.stringify(decodedToken.user))
              }
              if (!!decodedToken.permissions) {
                localStorage.setItem('role', decodedToken.permissions.role)
                localStorage.setItem(
                  'empresas',
                  JSON.stringify(decodedToken.permissions.empresas)
                )
              }
            })
            .catch(error => {
              localStorage.removeItem('accessToken')
              localStorage.removeItem('refreshToken')
              localStorage.removeItem('role')
              localStorage.removeItem('empresas')
              localStorage.removeItem('user')
            })
        } else {
          if (!!roles && roles.length > 0) {
            const role = localStorage.getItem('role')
            if (roles.includes(role)){
              return Promise.resolve()
            }
            return Promise.reject()
          }
        }
      } else if (!!required) {
        return Promise.reject()
      }
      return Promise.resolve()

    case AUTH_GET_PERMISSIONS:
      const role = localStorage.getItem('role')
      if (role == null) {
        return Promise.resolve(
          {
            role: "guest",
            isUserAdmin: false,
            empresas: {}
          }
        )
      }

      const empresas = JSON.parse(localStorage.getItem('empresas'))

      let isUserAdmin = !!role && (role === "admin")
      for (let key in empresas) {
      	if (empresas.hasOwnProperty(key)) {
          if (empresas[key].permissions.includes("admin_users")) {
            isUserAdmin = true
            break
          }
      	}
      }

      return Promise.resolve({ role, empresas, isUserAdmin })

    default:
      return Promise.reject('Unknown method')
  }
}

export default authProvider(`${process.env.API_URL}/api/v1/token`)
